
import React, { useState, useEffect } from 'react';
import { Document, Page, pdfjs, PDFPageItem } from 'react-pdf';
import  {
    Button, 
    ButtonGroup, 
    Spinner,
} from 'reactstrap';
import TratoLoader from './TratoLoader'
import { noop } from 'utils'
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import clsx from 'clsx';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const Controls = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  bottom: ${props => props.height ? '100px' : '60px'};
`
const ClickPanel = styled.div`
  position: absolute;
  cursor: pointer;
  width: 50%;
  z-index: 1000;
  height: 100%;
  right: ${props => props.right};
  left: ${props => props.left};
  top: ${props => props.top};
  bottom: ${props => props.bottom};
`
const options = {
    cMapUrl: `//cdn.jsdelivr.net/npm/pdfjs-dist@${pdfjs.version}/cmaps/`,
    cMapPacked: true
  };

export function PdfPlaceholder({ width = 600, height = 750 } = {}) {
    return (<div 
        className="pulse-animation d-flex justify-content-center align-items-center"
        style={{backgroundColor: 'rgb(224, 224, 224)', width, height }} 
    > 
      <TratoLoader className="rounded-circle" size="xl" />
    </div>)
}
const DEFAULT_WIDTH = 595;

function PdfPreview({ url, width: initialWidth = DEFAULT_WIDTH, onMouseUp, highlightSearch = '', pageNumber, initialPageNumber = 1, canvasRef, resetWidthOnUrlChange, clickPanels, controlsClassName, onPageChange = noop, onPageLoad = noop,  onDocumentLoad = noop, controls, children }) {
  const { t } = useTranslation();
  const [numPages, setNumPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [width, setWidth] = useState(initialWidth);

  const onPageLoadSuccess = (pageInfo) => {
    const rotation = pageInfo._pageInfo.rotate;
    const shouldInvertDimensions = [90, 270].includes(rotation);
    const [,,originalWidth, originalHeight] = pageInfo._pageInfo.view;
    const ratio = shouldInvertDimensions ? pageInfo.height/originalHeight : pageInfo.width/originalWidth

    onPageLoad({ 
      ...pageInfo,
      rotation,
      ratio: isNaN(ratio) ? 1 : ratio,
      width: shouldInvertDimensions ? pageInfo.height : pageInfo.width,
      height: shouldInvertDimensions ? pageInfo.width : pageInfo.height,
      areDimensionsInverted: shouldInvertDimensions,
      originalWidth: shouldInvertDimensions ? originalHeight : originalWidth,
      originalHeight: shouldInvertDimensions ? originalWidth : originalHeight
    })
  };

  const onDocumentLoadSuccess = ({numPages}) => {
    setNumPages(numPages);
    onDocumentLoad({ numPages })
  };

  const highlightPattern = (text, pattern) => {

    if (!pattern.length) {
      return text;
    }
  
    const textToTest = text.replace(/\s+/gi, ' ');
    const splitText = textToTest.toLowerCase().split(pattern.toLowerCase());

    if (splitText.length <= 1) {
      return textToTest;
    }
  
    const matches = textToTest.match(new RegExp(`${pattern}`, 'ig'));

    return splitText.reduce(
      (arr, element, index) =>
        matches?.[index]
          ? [...arr, element, <mark class="highlight">{matches[index]}</mark>]
          : [...arr, element],
      []
    );
  };

  const makeTextRenderer = (searchText) => (textItem) =>
    highlightPattern(textItem.str, searchText);


  const handleNextPage = () => {
      setCurrentPage(currentPage => {
        const newPage = Math.min(currentPage + 1, numPages)
        onPageChange(newPage)  
        return newPage;
      })
  }

  const handlePrevPage = () => {
      setCurrentPage(currentPage => {
        const newPage = Math.max(currentPage - 1, 1)
        onPageChange(newPage)  
        return newPage;
      })
  }

  useEffect(() => {
      if (pageNumber) {
        setCurrentPage(pageNumber)
      }
  }, [pageNumber])

  useEffect(() => {
    setCurrentPage(initialPageNumber)
    if (resetWidthOnUrlChange) setWidth(0)
  }, [url, initialPageNumber])

  useEffect(() => {
    setWidth(initialWidth)
  }, [initialWidth])

  return (
  <div className="d-flex flex-column h-100 overflow-hidden">
    <div className="overflow-hidden d-flex flex-column h-100">
      <div className="h-100 overflow-x-hidden">  
        <div className="position-relative">
          { clickPanels && <>
            <ClickPanel top={0} left={0} onClick={handlePrevPage} />
            <ClickPanel top={0} right={0} onClick={handleNextPage} />
          </> }
          <Document
              file={url}
              onLoadSuccess={onDocumentLoadSuccess}
              options={options}
              className="page-box-shadow mb-3"
              loading={<PdfPlaceholder />}
          >
              {/* {Array.from(new Array(numPages), (el, index) => ( */}
            <Page
                // className="w-100"
                // key={`page_${index + 1}`}
                pageNumber={currentPage}
                onLoadSuccess={onPageLoadSuccess}
                width={width}
                customTextRenderer={makeTextRenderer(highlightSearch)}
                onMouseUp={onMouseUp}
                renderInteractiveForms={true}
                loading={<PdfPlaceholder />}
                canvasRef={canvasRef}
            >
              {children}
            </Page>
              {/* ))} */}
              {/* <Outline pdf={pdf}/> */}
          </Document>
        </div>
      </div>
      <div>
      {controls &&
        <Controls className={clsx("text-center", controlsClassName)} height={true || width < 500}>
          <ButtonGroup className="shadow rounded bg-white">
            <Button size="lg" color="default" disabled={currentPage === 1} onClick={handlePrevPage}><i className="fas fa-caret-left" /></Button>
            <div className="align-self-center">
            {numPages ?
              <span>{currentPage} {t('common.of')} {numPages}</span>
              :
              <Spinner size="sm"/>
            }
            </div>
            <Button size="lg" color="default" disabled={currentPage === numPages} onClick={handleNextPage}><i className="fas fa-caret-right" /></Button>
          </ButtonGroup>
        </Controls>
        }
      </div>
    </div>
  </div>)
}

export default PdfPreview;


